import { isPast } from "date-fns"

import { Session } from "modules/ClientAccount/components"
import { BookingStatusMap } from "utils/interfaces"
import { CANCELED_STATUSES } from "modules/ClientAccount/constants"
import { showPaymentBlock } from "modules/ClientAccount/utils/showPaymentBlock"
import { Booking } from "modules/ClientAccount/utils/api"

function isCanceled(booking: Booking): boolean {
    return CANCELED_STATUSES.some((s) => s === booking.status)
}

export function toSession(booking: Booking): Session {
    const sessionEnded = isPast(new Date(booking.session_end_datetime))
    const canceled = isCanceled(booking)
    const paid =
        booking.status === BookingStatusMap.PAID ||
        booking.status === BookingStatusMap.PAID_AFTER_CANCELLATION
    const { available_for_booking } = booking.psy
    const bookNextSession = !!(available_for_booking.online || available_for_booking.in_person)
    return {
        bookNextSession,
        createdByPsychologist: booking.created_by_psychologist,
        startDatetime: booking.session_start_datetime,
        endDatetime: booking.session_end_datetime,
        previousStartDatetime: booking.previous_session_start_datetime,
        startDatetimeChangedDatetime: booking.session_start_datetime_changed_datetime,
        isOffline: !booking.service_type.online,
        price: booking.price,
        forFree: booking.price == 0,
        sessionEnded: sessionEnded || canceled,
        showPaymentBlock: showPaymentBlock(booking.status),
        isRefundPossible: booking.is_refund_possible,
        isRefundApplied: booking.status === BookingStatusMap.CANCELLED_AFTER_PAYMENT,
        paid:
            paid ||
            booking.status === BookingStatusMap.CANCELLED_AFTER_PAYMENT ||
            booking.status === BookingStatusMap.CANCELLED_WITHOUT_REFUND,
        cancellationDatetime: booking.cancellation_info?.datetime,
        cancellationInitiator: booking.cancellation_info?.initiator,
        canceled,
        psy: booking.psy,
        bookingHash: booking.booking_hash,
        currency: booking.currency,
        hasFixedSessionTime: booking.has_fixed_session_time,
        call: booking.call,
        isBookingAvailableForCall: booking.is_booking_available_for_call,
    }
}
